/**
 *
 * @param {string} formattedDate
 * @param {string | undefined} minDateValidation
 * @param {string | undefined} maxDateValidation
 * @returns string
 */

export const errors = {
  month: 'Enter a valid month',
  year: 'Enter a valid year',
  date: 'Enter a valid date'
};

export function validateDate({
  formattedDate,
  minDateValidation,
  maxDateValidation,
  errorCustom
}) {
  if (!formattedDate) {
    return '';
  }
  const currentDate = splitDate(formattedDate);
  const dateReg = new RegExp('(0[1-9]|1[0-9]|2[0-9]|3[0-1])', 'g'); // 01 -> 31
  const monthReg = new RegExp('(0[1-9]|1[0-2])', 'g'); // 01 -> 12
  if (currentDate.date && !dateReg.test(String(currentDate.date))) {
    return errorCustom ?? errors.date;
  }
  if (currentDate.month && !monthReg.test(String(currentDate.month))) {
    return errorCustom ?? errors.month;
  }
  if (
    currentDate.month === '02' &&
    !isLeapYear(Number(currentDate.year)) &&
    Number(currentDate.date) > 28
  ) {
    return errorCustom ?? errors.year;
  }

  const minDate = minDateValidation
    ? splitDate(minDateValidation)
    : { time: 0 };
  if (currentDate.time < minDate.time) {
    return errorCustom ?? errors.year;
  }

  if (!maxDateValidation) {
    return '';
  }
  const maxDate = splitDate(maxDateValidation);

  if (currentDate.time < minDate.time || currentDate.time > maxDate.time) {
    return errorCustom ?? errors.year;
  }
  return '';
}

/**
 * 
 * @param {string} dateInput 
 * @returns Object {
    year: string, // ex: 2023
    month: string, // ex: 03 (2 digits)
    date: string,
    time: number
 }
 */
function splitDate(dateInput) {
  const splitedMinDate = dateInput.replace(/ /g, '').split('/');
  const year = splitedMinDate.pop();
  const month = splitedMinDate.pop();
  const date = splitedMinDate.pop() || '';
  const fullYear =
    year && year?.length < 4 ? Number('20' + year) : Number(year);
  return {
    year: year && year?.length < 4 ? '20' + year : year,
    month,
    date,
    time: date
      ? new Date(fullYear, Number(month) - 1, Number(date)).getTime()
      : new Date(fullYear, Number(month) - 1).getTime()
  };
}

/**
 *
 * @param {nunber} year
 * @returns boolean
 */
function isLeapYear(year) {
  return new Date(year, 1, 29).getDate() === 29;
}

/**
 * If the input is the same length with the display format (ex: DD / MM / YYYY) -> finished typing
 * @param {string} value
 * @param {Array<any>} displayFormat
 * @returns boolean
 */
export function isEndTyping(value, displayFormat) {
  return value.length === displayFormat.length;
}
1;
